import './footer.css'

const Footer = () => {
  return (
    <footer>
      <h3>Code+</h3>
      <strong>&copy;2022. Desarrollado por David Granados</strong>
    </footer>
  )
}

export default Footer